"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  result["default"] = mod;
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var field_validation_errors_1 = require("./field-validation-errors");
var label_1 = require("./label");
var ListBox = function ListBox(props) {
  var field = props.field,
    items = props.field.model.items,
    value = props.value,
    _onChange = props.onChange,
    tracker = props.tracker,
    errors = props.errors;
  var finalValue = value;
  // react does not like an array as a value unless multiple select is allowed
  // (even if the array is always length 1)
  if (!field.model.multipleSelection) {
    finalValue = value[0];
  }
  // note: the value for list field types is an array (of selected values)
  // dropdown is single-select so we use value[0] for its value
  return react_1.default.createElement(react_1.Fragment, null, react_1.default.createElement(label_1.Label, __assign({}, props)), react_1.default.createElement("select", {
    className: field.model.cssClass,
    id: field.valueField.id,
    name: field.valueField.name,
    value: finalValue,
    size: field.model.rows,
    multiple: field.model.multipleSelection,
    onChange: function onChange(e) {
      return handleOnChange(field, e.target.options, _onChange);
    },
    onFocus: function onFocus() {
      return tracker.onFocusField(field, value);
    },
    onBlur: function onBlur() {
      return tracker.onBlurField(field, value, errors);
    }
  }, items.map(function (item) {
    return react_1.default.createElement("option", {
      key: item.itemId,
      value: item.value
    }, item.text);
  })), react_1.default.createElement(field_validation_errors_1.FieldValidationErrors, __assign({}, props)));
};
function handleOnChange(field, options, callback) {
  var valid = true;
  var errorMessages = [];
  var newValues = [];
  for (var i = 0; i < options.length; i += 1) {
    if (options[i].selected) {
      newValues.push(options[i].value);
    }
  }
  // custom client validation logic here
  if (field.model.required && newValues.length === 0) {
    valid = false;
    errorMessages.push(field.model.title + " is required");
  }
  callback(field.valueField.name, newValues, valid, errorMessages);
}
exports.default = ListBox;